import { render } from "./PageAbout.vue?vue&type=template&id=a27e0308"
import script from "./PageAbout.vue?vue&type=script&lang=js"
export * from "./PageAbout.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__